<template>
  <BOverlay
    :show="loading"
    spinner-variant="primary"
    variant="light"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <div
      :id="id"
      class="overflow-y-auto h-[50vh]"
      @scroll="handleScroll"
    >
      <b-table-simple>
        <b-thead class="!sticky !top-0 !z-10">
          <!-- First header row: Group headers -->
          <b-tr>
            <b-th
              class="align-middle !border-none !rounded-tl-xl !capitalize !font-medium !text-[14px]"
            >
              Nama Business Manager
            </b-th>
            <b-th
              class="align-middle !border-none !capitalize !font-medium !text-[14px]"
            >
              Estimasi Penggunaan
            </b-th>
            <b-th
              class="align-middle !border-none !capitalize !font-medium !text-[14px]"
            >
              Kapasitas Akun
            </b-th>
            <b-th
              class="text-center align-middle !border-none !rounded-tr-xl !capitalize !font-medium !text-[14px]"
            >
              Aksi
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody class="divide-y">
          <b-tr
            v-for="(item, index) in items"
            :key="index"
          >
            <!-- Business Manager -->
            <b-td>
              <div class="flex flex-col items-start gap-y-[.5rem] text-black">
                <p>{{ item.bm_name }}</p>
                <span class="bg-[#F4F4F4] border-[#E2E2E2] border-[2px] rounded-md py-[.25rem] px-[.5rem]">{{ item.bm_id }}</span>
              </div>
            </b-td>

            <!-- Estimasi Pengunaan -->
            <b-td>
              <span class="text-black">{{ IDR(item.estimated_balance || 0) }}</span>
            </b-td>

            <!-- Kapasitas Slot -->
            <b-td>
              <div class="flex items-center justify-between mb-[.5rem]">
                <p>
                  <span class="font-medium text-black">{{ item.account_count }}</span>/{{ item.account_limit }} User
                </p>
                <span
                  class="py[.25rem] px-[.75rem] rounded-full"
                  :class="{
                    'success-color-badge': item.usage_percentage < 70,
                    'warning-color-badge': item.usage_percentage >= 70 && item.usage_percentage <=90,
                    'danger-color-badge': item.usage_percentage > 90
                  }"
                >{{ item.usage_percentage }}%</span>
              </div>
              <div class="bg-[#E2E2E2] rounded-sm overflow-hidden">
                <div
                  class="p-[.3rem]"
                  :class="{
                    'transparent-color-bar': item.usage_percentage < 1,
                    'success-color-bar': item.usage_percentage < 70,
                    'warning-color-bar': item.usage_percentage >= 70 && item.usage_percentage <=90,
                    'danger-color-bar': item.usage_percentage > 90
                  }"
                  :style="{ width: `${item.usage_percentage}%` }"
                />
              </div>
            </b-td>

            <!-- Aksi -->
            <b-td>
              <div class="flex justify-center items-center gap-[.5rem]">
                <b-button
                  variant="light"
                  class="bg-[#F4F4F4] text-[#828282] !p-[.5rem]"
                  @click="() => viewDetail(item)"
                >
                  <span class="k-eye" />
                </b-button>
                <b-button
                  variant="light"
                  class="bg-[#F4F4F4] text-[#828282] !p-[.5rem]"
                  @click="() => editAccount(item)"
                >
                  <span class="k-edit" />
                </b-button>
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </BOverlay>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IDR,
    }
  },
  methods: {
    viewDetail({ id, bm_name }) {
      this.$emit('view-detail', { id, bm_name })
    },

    editAccount(item) {
      this.$emit('edit-account', item)
    },

    handleScroll(event) {
      this.$emit('scroll', event)
    },
  },
}
</script>

<style scoped>
p {
  margin: 0;
}

.success-color-badge {
  border: 1px solid #34A770;
  background-color: #DCF3EB;
  color: #10673E;
}

.warning-color-badge {
  border: 1px solid #FBA63C;
  background-color: #FCEBBE;
  color: #AF6A13;
}

.danger-color-badge {
  border: 1px solid #E31A1A;
  background-color: #FFEDED;
  color: #79170A;
}

.success-color-bar {
  background-color: #34A853;
}

.warning-color-bar {
  background-color: #FBBC05;
}

.danger-color-bar {
  background-color: #E31A1A;
}

.transparent-color-bar {
  background-color: transparent;
}
</style>
